// extracted by mini-css-extract-plugin
export default {"cardContainer":"Wordle_cardContainer__K+EhZ","container":"Wordle_container__s8rW9"};